import { AnyAction } from 'redux';
import { BaseTransientState, Rolle } from '@ps20-frontend/frontend-models';
import {
  GlobalActions,
  GlobalCommonInsuranceDataReceivedAction,
  GlobalFeatureToggleReceivedAction,
  GlobalRegexReceivedAction,
  GlobalRoleDeterminedAction,
  SDWAbsprungData,
} from '@ps20-frontend/shop-integration-redux';
import { UnfActions } from '../unfActions';

export interface TransientState extends BaseTransientState, Rolle {
  amisSessionId: string;
  sdw: SDWAbsprungData;
}

export const transientStateReducer = function (
  sectionState: TransientState = null,
  action: AnyAction,
): TransientState {
  switch (action.type) {
    case GlobalActions.COMMON_INSURANCE_DATA_RECEIVED:
      return commonInsuranceDataReceived(sectionState, action);
    case UnfActions.ZURUECK_ZUM_SHOP_MODAL_OPEN:
      return { ...sectionState, zurueckZumShopModalOpen: true };
    case UnfActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE:
      return { ...sectionState, zurueckZumShopModalOpen: false };
    case GlobalActions.ROLE_DETERMINED:
      return { ...sectionState, role: (action as GlobalRoleDeterminedAction).payload.role };
    case GlobalActions.FEATURE_TOGGLE_RECEIVED:
      return {
        ...sectionState,
        featureToggles: (action as GlobalFeatureToggleReceivedAction).payload,
      };
    case GlobalActions.REGEXPS_RECEIVED:
      return { ...sectionState, regexps: (action as GlobalRegexReceivedAction).payload };
    case GlobalActions.TARIFIERUNG_HAS_STARTED:
      return { ...sectionState, tarifierungIsInProgress: true };
    case GlobalActions.TARIFIERUNG_HAS_ENDED:
      return { ...sectionState, tarifierungIsInProgress: false };
    case GlobalActions.TARIFIERUNG_CANCELED:
      return { ...sectionState, tarifierungIsInProgress: false };
    case GlobalActions.SET_PRICE_GUARANTEE:
      return { ...sectionState, priceGuarantee: action.payload };
    case GlobalActions.CHANGE_RELEVANT_RISKDATA_HASH:
      return { ...sectionState, priceGuarantee: false };
    case GlobalActions.SETTINGS_RECEIVED:
      return {
        ...sectionState,
        settings: action.payload,
      };
    case GlobalActions.KOOPERATIONEN_LIST_RECEIVED: {
      return {
        ...sectionState,
        kooperationen: action.payload,
      };
    }
    default:
      return sectionState;
  }
};

export function commonInsuranceDataReceived(
  sectionState: TransientState,
  action: GlobalCommonInsuranceDataReceivedAction,
): TransientState {
  return {
    ...sectionState,
    role: action.payload.role,
    amisSessionId: action.payload.amisSessionId,
    sdw: action.payload.sdw,
    kooperationen: action.payload.kooperationen,
  };
}
